module.exports = __webpack_public_path__ + "img/img_login.d91da63a.jpg";